module.exports = __webpack_public_path__ + "static/media/激光切割简易版气象站.fa7725cb.png";